'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.daily_price_report', {
        template: '<daily-price-report></daily-price-report>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/price_report/daily/daily_price_report.routes.js